import React, { useEffect, useState } from 'react';
import api from '../../common/api';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/styles/makeStyles";
import { ConfirmDialog, MaterialTable } from '../../components';
import useTheme from '@material-ui/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FeedStock from './components/feedStocks'
import Icon from '@material-ui/core/Icon';
import moment from 'moment'
import Mobile from "./components/mobile";
import SearchIcon from '@material-ui/icons/Search';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(theme => ({
    root: props => ({
        margin: props.isDesktop ? theme.spacing(4) : theme.spacing(1)
    }),
    topBar: {
        marginBottom: theme.spacing(2)
    },
    link: {
        display: 'flex',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },
    searchButton: {
        color: 'white',
        width: theme.spacing(21.25),
        backgroundColor: '#EF5350',
        '&:hover': {
            backgroundColor: '#E53935',
        },
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        marginLeft: theme.spacing(1.6),
        marginBottom: theme.spacing(4)
    },
    success: {
        color: 'white',
        backgroundColor: '#4CAF50',
        '&:hover': {
            backgroundColor: '#388E3C',
        },
        width: theme.spacing(13.75),
        margin: theme.spacing(1),
        padding: theme.spacing(1),
        marginLeft: theme.spacing(1.6),
        marginBottom: theme.spacing(4)
    }
}));

let currentFeedStockData = undefined;
let editMode = false;

const FeedStockView = ({ showError, showMessage, history, match }) => {

    const [feedStockData, setFeedStockData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterSelectedStartDate, setFilterSelectedStartDate] = useState(null);
    const [filterSelectedEndDate, setFilterSelectedEndDate] = useState(null);
    const [showFeedStockDialog, setShowFeedStockDialog] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [Shed, setShed] = useState([])
    const [farms, setFarms] = useState([])
    const [MaterialList, setMaterialList] = useState(null);
    const [MaterialTypeList, setMaterialTypeList] = useState(null);
    const [MaterialType, setMaterialType] = useState(null);
    const theme = useTheme();

    const handleFilterStartDateChange = date => {
        setFilterSelectedStartDate(date);
    };

    const handleFilterEndDateChange = date => {
        setFilterSelectedEndDate(date);
    };

    const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });
    const classes = useStyles({ isDesktop });

    function onNewFeedStockDatas(event) {
        editMode = false;
        setErrorMessage("");
        event.preventDefault();
        setShowFeedStockDialog(true);
    }

    function handleFeedStockClose() {
        setErrorMessage(null);
        currentFeedStockData = undefined;
        setShowFeedStockDialog(false);
    }

    function handleDeleteConfirmClose() {
        setShowDeleteConfirm(false);
    }

    function handleMaterialTypeChange(event) {
        setMaterialType(MaterialTypeList[event.target.value])
    }

    //Get all farms API Call
    const getAllFarms = () => {
        showError('');
        showMessage('');

        const response = api.get('farm');

        response.then(res => {
            setFarms([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    console.log(err.message)
            } else {
                console.log('Unknown Error')
            }
        });

        return response;
    };

    function getAllSheds(farmID) {
        setLoading(true);
        showMessage('');
        const response = api.get(`farm/${farmID}/shed`);

        response.then(res => {
            setShed(res);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setErrorMessage('No Sheds');
                else
                    setErrorMessage(err.message)
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        });

        return response;
    };

    const onFeedStockDeleteConfirm = () => {
        if (currentFeedStockData && currentFeedStockData.id) {
            setShowDeleteConfirm(false);
            setLoading(true);
            showError('');
            const response = api.delete(`feed-stock/delete/${currentFeedStockData.id}/${match.params["farmID"]}`);

            response.then(res => {
                if (res) {
                    let index = feedStockData.findIndex((srcFeedStock) => {
                        return srcFeedStock.id === currentFeedStockData.id;
                    });
                    let newFeedStockData = [...feedStockData];
                    newFeedStockData.splice(index, 1);
                    setFeedStockData(newFeedStockData);
                }
            }).catch(err => {
                if (err.message) {
                    if (err.message === 'Bad Request' || err.message === 'No data found')
                        showError('FeedStockData not Deleted');
                    else
                        showError(err.message)
                } else {
                    showError('Unknown Error')
                }
            }).finally(() => {
                setLoading(false);
                currentFeedStockData = undefined;
            });
        }
    };

    const removeErrorMessage = value => {
        setErrorMessage('');
    }

    const onFeedStockDataDelete = (FeedStockData) => {
        currentFeedStockData = FeedStockData;
        setShowDeleteConfirm(true);
    };

    const onFeedStockDatasSave = (FeedStockData, setpopuploading) => {
        showMessage('');
        const response = api.post('feed-stock/create', FeedStockData);

        response.then(res => {
            let materials = MaterialList[res.materialType]
            let { materialName } = materials.find((el) => el.materialMasterId === res.materialMasterId)
            if (res.isStorage === 0) {
                let { name: shedName } = Shed.find((el) => el.id === res.shedId)
                res.shedName = shedName
            } else {
                let farmName = farms.find((farm) => { return farm.id === res.farmId }).name;
                let transferFarmName = farms.find((farm) => { return farm.id === res.transferFarmID }).name;
                res.shedName = farmName + "→" + transferFarmName + "(Storage)"
            }
            let materialType = FeedStockData.materialType

            res.materialName = materialName
            res.materialType = materialType
            setFeedStockData([...feedStockData, res]);

            setShowFeedStockDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found') {
                    setErrorMessage('FeedStockData not added');
                }
                else if (err.message === 'duplicate key') {
                    setErrorMessage("Duplicate entry. Feed Stock already exists")
                } else if (err.message === 'no batch found') {
                    setErrorMessage(`No batch found for shed ${FeedStockData.shedName} on ${moment(FeedStockData.date).format("DD-MM-YYYY")}`)
                } else if (err.message === 'no stock') {
                    setErrorMessage('Material with available stock 0 cannot be added');
                }
                else {
                    setErrorMessage(err.message)
                }
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
            setpopuploading(false);
        });
    };

    const onFeedStockDataEdit = async (FeedStockData) => {
        setErrorMessage("");
        const farmId = FeedStockData.transferFarmID || FeedStockData.farmId;
        const updatedSheds = await getAllSheds(farmId);
        currentFeedStockData = {
            ...FeedStockData,
            feedStockTypeIdx: MaterialList[FeedStockData.materialType].findIndex((material) => { return material.materialMasterId === FeedStockData.materialMasterId; }),
            shedTypeIdx: updatedSheds.findIndex((shed) => { return shed.id === FeedStockData.shedId; }),
            farmIndex: farms.findIndex((farm) => { return FeedStockData.isTransfer ? farm.id === FeedStockData.transferFarmID : farm.id === FeedStockData.farmId; }),
            materialTypeIdx: MaterialTypeList.findIndex((el) => { return el.value === FeedStockData.materialTypeId }),
            isStorage: FeedStockData.isStorage,
        };
        setMaterialType(MaterialTypeList[MaterialTypeList.findIndex((el) => { return el.value === FeedStockData.materialTypeId })])
        editMode = true;

        setShowFeedStockDialog(true);
    };

    const onFeedStockUpdate = (FeedStockData, setPopupLoading) => {
        const response = api.post(`feed-stock/update/${FeedStockData.id}/${match.params["farmID"]}`, FeedStockData);
        response.then((res) => {
            let index = feedStockData.findIndex((srcFeedStock) => {
                return srcFeedStock.id === FeedStockData.id;
            });
            setFeedStockData([...feedStockData.slice(0, index),
            { ...res },
            ...feedStockData.slice(index + 1)]);

            setShowFeedStockDialog(false);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'Not Updated') {
                    setErrorMessage('Feed Stock Data not Updated');
                } else if (err.message === 'no batch found') {
                    setErrorMessage(`No batch found for shed ${FeedStockData.shedName} on ${moment(FeedStockData.date).format("DD-MM-YYYY")}`)
                }
                else if (err.message === 'no stock') {
                    setErrorMessage('Material with available stock 0 cannot be updated');
                }
                else {
                    setErrorMessage(err.message)
                }
            } else {
                setErrorMessage('Unknown Error')
            }
        }).finally(() => {
            setPopupLoading(false)
            setLoading(false);
        })
    };

    //Get all feedStockData API Call
    const getAllFeedStockData = () => {
        if (filterSelectedEndDate !== null && filterSelectedStartDate !== null &&
            filterSelectedEndDate < filterSelectedStartDate) {
            showError('Start Date is Greater than or Equal to End Date');
            return
        }
        setShowFeedStockDialog(false);
        showError('');
        showMessage('');
        setLoading(true);

        const response = api.post(`feed-stock/data/${match.params["farmID"]}`, {
            date: filterSelectedStartDate,
            endDate: filterSelectedEndDate,
        });

        response.then(res => {
            setFeedStockData([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found') {
                    setFeedStockData([]);
                    showError('No Feed Stock Found');
                } else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        }).finally(() => {
            setLoading(false);
        })
        return response;
    }

    //Get the feed materials available in storage
    const getFeedList = () => {
        showError('');
        showMessage('');

        const response = api.post(`/feed-stock/get-feed-list/${match.params["farmID"]}`, {});
        response.then(res => {
            setMaterialList({ Feed: (res && Array.isArray(res.Feed)) ? res.Feed : [] })
            setMaterialTypeList([{ key: 0, value: 5, type: 'Feed' }])
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    setMaterialList({ Feed: [] })
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
            setMaterialTypeList([{ key: 0, value: 5, type: 'Feed' }])
        });

        return response;
    }

    //Get all Shed API Call
    const onGetShed = (farmId) => {
        setShed([])
        showError('');
        const response = api.get(`farm/${farmId}/shed`);
        response.then(res => {
            setShed([...res]);
        }).catch(err => {
            if (err.message) {
                if (err.message === 'Bad Request' || err.message === 'No data found')
                    showError('No Sheds');
                else
                    showError(err.message)
            } else {
                showError('Unknown Error')
            }
        });
    }

    const onload = () => {
        setLoading(true);
        Promise.all([getAllFeedStockData(), getAllFarms(), getAllSheds(match.params["farmID"]), getFeedList()]).finally(() => {
            setLoading(false);
        });
    }

    const clearDateRangeFilter = () => {
        setFilterSelectedStartDate(null)
        setFilterSelectedEndDate(null)
    }

    useEffect(onload, []);
    let materialColumnDefaults = { title: 'Material Name', field: 'materialName', defaultSort: 'asc' }
    let materialColumn = {
        ...materialColumnDefaults,
        render: rowData => <Mobile data={rowData}
            onEdit={() => { onFeedStockDataEdit(rowData) }}
            onDelete={() => { onFeedStockDataDelete(rowData) }}
        />
    }
    let actions = [];
    if (isDesktop) {
        materialColumn = materialColumnDefaults
        actions = [
            {
                icon: () => <Icon color='primary'>edit</Icon>,
                tooltip: 'Edit FeedStockData',
                onClick: (event, rowData) => onFeedStockDataEdit(rowData)
            },
            {
                icon: () => <Icon color='error'>delete</Icon>,
                tooltip: 'Delete FeedStockData',
                onClick: (event, rowData) => onFeedStockDataDelete(rowData)
            }
        ]
    }

    return <div className={classes.root}>
        <Grid
            container
            justify='space-between'
            alignItems='flex-end'
            className={classes.topBar}
        >
            <Grid>
                <Typography display="block" variant="h3" gutterBottom>
                    Move Feed to Shed
                </Typography>
            </Grid>
            <Grid>
                <Button variant="contained" color="primary" onClick={onNewFeedStockDatas}>Add Feed Stock</Button>
            </Grid>
        </Grid>
        <Grid
            spacing={3}
            justify="flex-start"
            alignItems="center">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    autoOk
                    className={classes.formControl}
                    margin="normal"
                    variant="inline"
                    label="From"
                    format="dd/MM/yyyy"
                    value={filterSelectedStartDate || null}
                    onChange={handleFilterStartDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    style={{ marginRight: 20 }}
                />
                <KeyboardDatePicker
                    className={classes.formControl}
                    autoOk
                    margin="normal"
                    variant="inline"
                    label="To"
                    format="dd/MM/yyyy"
                    value={filterSelectedEndDate || null}
                    onChange={handleFilterEndDateChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />
            </MuiPickersUtilsProvider>
            <Button onClick={getAllFeedStockData} className={classes.success}>Search <SearchIcon /></Button>
            <Button onClick={clearDateRangeFilter} className={classes.searchButton}>Clear Search <CloseIcon /></Button>
        </Grid>
        <MaterialTable
            isLoading={loading}
            columns={[
                { title: 'No', field: 'id', hidden: false },
                {
                    title: 'Date', field: 'date', hidden: !isDesktop,
                    render: rowData => {
                        return <span>{moment(rowData.date).format("DD-MM-YYYY")}</span>
                    }
                },
                materialColumn,
                { title: 'Material Type', field: 'materialType', hidden: !isDesktop, editable: 'never' },
                { title: 'Shed/Storage', field: 'shedName', hidden: !isDesktop, editable: 'never' },
                { title: 'Quantity', field: 'quantity', hidden: !isDesktop, editable: 'never' },
                {
                    title: 'Cost', field: 'cost', hidden: !isDesktop,
                    render: rowData => rowData.cost.toFixed(2)
                },
            ]}
            data={feedStockData}
            title='Feed Stock'
            options={{
                actionsColumnIndex: -1,
                search: true,
                showTitle: true,
                toolbar: true
            }}
            actions={actions}
        />
        <FeedStock errorMessage={errorMessage} showDialog={showFeedStockDialog} handleClose={handleFeedStockClose} onSave={onFeedStockDatasSave} onEdit={onFeedStockUpdate}
            editMode={editMode} data={currentFeedStockData} deleteErrorMessage={removeErrorMessage} match={match} shed={Shed} materialList={MaterialList}
            materialTypeList={MaterialTypeList} materialType={MaterialType}
            handleMaterialType={handleMaterialTypeChange} onGetShed={onGetShed} farms={farms}
        />
        <ConfirmDialog showDialog={showDeleteConfirm}
            handleClose={handleDeleteConfirmClose}
            onConfirm={onFeedStockDeleteConfirm}
            title='Delete Feed Stock ?'
            subText='This action will delete the Feed Stock Details. Please confirm.' />
    </div>
}

export default FeedStockView;
